import type { FaireProductEntity } from "../../entity_types/product";

export const p_au3ybzfp6k: FaireProductEntity = {
  token: "p_au3ybzfp6k",
  type: "product",
  name: "Softies x The Fill All Day Fresh™ Fabric & Room Spray",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/e86c3d56d582b37a507435fffaef7234090758cc1ccc516115736437964f2277.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23e83b379c143b18765fc42c979abcf796c0bb431835161ca566591928d8bee0.png",
    "https://cdn.faire.com/fastly/f7bd2520c2f2ebc1b24ce2c0143415ac517cc79a0d305d3cf159bae1085c1b6b.png",
    "https://cdn.faire.com/fastly/d5acdc296ba309719dcc11d38a5c7223bdd06a8779c39082ce20a4246ca3b86e.png"
  ],
  priceDollars: 11,
  description: "Created to infuse Softies softness into your everyday life, this fabric and room spray instantly freshens between washes. Perfect between wears or whenever you need a quick refresh, it revives fabrics so they feel clean, comfortable, and ready to wear. Designed for loungewear, bedding, upholstery, closets, and rooms, including dry-clean-only pieces.\n\nSAFETY SHEET\n\nCALIFORNIA CLEANING PRODUCT RIGHT TO KNOW DISCLOSURE\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:16.683Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
